module.exports = __webpack_public_path__ + "img/2.9ef40279.svg";